 <template>
  <div class="app-citreon">
    <nav
      class="navbar navbar-light navbar-expand-lg p-0 border-0 shadow"
      style="background: #e6e6e6; height: 50px"
    >
      <div class="container">
        <a href class="navbar-brand router-link-active">
          <img :src="peu" width="40px" alt />
          <span>
            <img :src="peulogo" width="90px" alt />
          </span>
        </a>
        <div class="mobilecitreonnav">
          <ul class="nav navbar-nav ml-md-auto text-uppercase">
            <li class="nav-item peulink">
              <a
                href="https://www.citroen.com.gh/"
                class="nav-link"
                target="_blank"
                style="color: #505050 !important"
              >
                EXPLORE Citroën GHANA
                <i class="el-icon-arrow-right" style></i>
              </a>
            </li>
          </ul>
        </div>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse container-fluid d-none d-md-block"
        >
          <ul class="nav navbar-nav ml-md-auto text-uppercase">
            <li class="nav-item py-md-3 peulink">
              <a
                href="https://www.citroen.com.gh/"
                class="nav-link"
                target="_blank"
                style="color: #505050 !important"
              >
                EXPLORE Citroën GHANA
                <i class="el-icon-arrow-right" style></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="citreon">
      <div class="container">
        <div class>
          <div class="citreon-title">
            <!-- <h5 >Comfort is the new Cool</h5> -->

            <h2>Citroën</h2>
            <h2>SUV RANGE</h2>
            <div style="margin-top:1.5rem">
              <h4>MORE COMFORT</h4>
              <h4>MORE MODULARITY</h4>

               <a
                href="https://www.citroen.com.gh/"
                class="btn btn-info"
                target="_blank"
                style="color: #fff !important; background:#dd2b4f; border-radius:4px;border:0px solid #dd2b4f;text-transform:uppercase"
              >
                EXPLORE Citroën GHANA
                <i class="el-icon-arrow-right" style></i>
              </a>
            </div>
            <!-- <h1>
             COMFORT <br />
                <sup
                  style="
                    vertical-align: super;
                    font-size: 16px;
                    margin-left: 3rem;
                  "
                  >IS THE NEW</sup
                >
                 <strong>COOL</strong>
               
              
            </h1>-->
          </div>
        </div>

        <div class>
          <div class="citreon-content">
            <div style="display:flex">
              <div style="border-top:1px solid black;width:20px;margin-top:0.6rem"></div>
              <p>authorised distributor</p>
              <div style="border-top:1px solid black;width:20px;margin-top:0.6rem"></div>
            </div>

            <h6 class="silver">
              <span>
                <!-- <img :src="starlogo" width="30px" /> -->
              </span> Silver star Auto
            </h6>
            <!-- <ul style="padding-left: 0.5rem">
              <li>FREE GHS 1000 WORTH OF FUEL FOR X’MAS</li>
              <li>FREE FIRST ANNUAL SERVICE</li>
              <li>FREE CAR VALET/ POLISHING</li>
              <li>FFREE TYRE HEALTH CHECK</li>
            </ul>
            <p><strong>STOCK AVAILABLE, RUSH NOW!!!</strong></p>-->
            <!-- <h6>AN ULTRA COMFORTABLE AND FLEXIBLE SUV</h6>
            <p>Classically SUV-shaped with its large 720mm diameter wheels, its robust and muscular design and it’s raised ground clearance of 230mm. Its unique personality and strong style choices such as its Airbump®.</p>-->
            <!-- <div style="margin-top: 5%">
              <a class="cexplore" style="" href="https://www.citroen.com.gh/">
                EXPLORE Citroën GHANA
                <i class="el-icon-arrow-right" style="padding-left: 2%"></i>
              </a>
            </div>
            <div style="margin-top: 5%">
              <el-button
                class="ctest"
                type="info"
                style="
                  border: 1px solid #bcbcbc;
                  background: #bcbcbc;
                  color: #000;
                  width: 13.3rem;
                  padding-left: 0;
                "
                @click="test"
              >
                BOOK A TEST DRIVE
                <i class="el-icon-arrow-right" style="padding-left: 5%"></i>
              </el-button>
            </div>-->
            <!-- <div style="top:5%">
<p style="">Call <span>0554</span> <span style="padding-left:0.3rem">336</span> <span style="padding-left:0.3rem" >869</span> </p>
            </div>
            <div style="top:5%">
<p style=" font-size:16px">Terms and Conditions Apply.</p>
            </div>-->
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <div class="bg-dark" style="padding-top: 3rem">
      <div class="container">
        <core style="border-top: 1px solid rgba(255, 255, 255, 0.24)"></core>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import CoreValues from "../components/Core.vue";
var peu = require("../assets/img/newcitreon.png");
var starlogo = require("../assets/img/starlogo.png");
export default {
  name: "Citroën",
  components: {
    core: CoreValues
  },
  data() {
    return { peu, starlogo };
  },
  metaInfo() {
    return {
      title: "Citroën"
    };
  },
  computed: {},
  methods: {
    test() {
      this.$router.push("/book");
    },
    opensite() {
      this.window.location.href = "https://www.citroen.com.gh/";
    }
  },
  created() {}
};
</script>
